/**
 * Builds Stripe `success_url` with `{CHECKOUT_SESSION_ID}` placeholder and `return_to`
 * so `/payment/success` can send the user back to where checkout started.
 *
 * - Same origin as the payment success page: `return_to` is path + search + hash.
 * - Different origin (set `VITE_CHECKOUT_SUCCESS_ORIGIN` on the editor build): `return_to` is full `location.href`.
 */
export function buildStripeCheckoutSuccessUrl(): string {
  if (typeof window === 'undefined') {
    return '/payment/success?checkout_id={CHECKOUT_SESSION_ID}';
  }

  const paymentOrigin = import.meta.env.VITE_CHECKOUT_SUCCESS_ORIGIN || window.location.origin;

  const sameOrigin = paymentOrigin === window.location.origin;
  const returnTo = sameOrigin
    ? `${window.location.pathname}${window.location.search}${window.location.hash || ''}`
    : window.location.href;

  const returnQuery = encodeURIComponent(returnTo);
  return `${paymentOrigin}/payment/success?checkout_id={CHECKOUT_SESSION_ID}&return_to=${returnQuery}`;
}
